import React from "react";
import Card from "components/card";
import Button from "components/button";
import { ANNOUNCEMENT_COLOR_OPTIONS } from "variables/constants";
import { displayIcon } from "variables/icons";
import dayjs from "dayjs";

const AnnouncementModal = ({ announcement, onClose }) => {

    const colorOption = ANNOUNCEMENT_COLOR_OPTIONS.find(
        color => color.value  === announcement?.ann_color_class
    );

    return (
        <Card className="gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-[500px]">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <div className="flex items-center gap-2 mb-1">
                    <div className="flex items-start gap-3 mb-3">
                        <div className={`p-3 rounded-xl gradient ${colorOption?.gradient}`}>
                            {displayIcon(announcement?.ann_icon, "w-6 h-6 text-white" )}
                        </div>
                        <div className="flex-1">
                            <h2 className="font-semibold text-[16px]">
                                {announcement?.ann_title}
                            </h2>
                            {announcement?.ann_event_date_from &&
                                <p className="text-sm muted-text">
                                    {dayjs(announcement?.ann_event_date_from).format("MMM D, YYYY")}
                                    {announcement?.ann_event_date_to && 
                                    ` - ${dayjs(announcement.ann_event_date_to).format("MMM D, YYYY")}`}
                                </p>
                            }

                        </div>
                    </div>
                </div>
            </div>
            <div className="space-y-4">
                <p className="text-[13px] tracking-normal muted-text">
                    {announcement?.ann_description}
                </p>
                {announcement?.ann_event_time_from && (
                    <div className="p-3 rounded-lg bg-slate-50 border border-slate-200 dark:bg-white/10">
                        <div className="flex items-center gap-2 mb-1">
                            {displayIcon("Info", "w-4 h-4 text-blue-600 dark:text-blue-400" )}
                            <span className="text-[12px] font-semibold">
                                Priority Level
                            </span>
                        </div>
                        <p className="text-[11px] capitalize muted-text">
                            {announcement?.priority_level}
                        </p>
                    </div>
                )}
                <Button
                    onClick={onClose}
                    className="access-button btn-got-it text=[12px] w-full"
                >
                    Got it
                </Button>
            </div>
        </Card>
    )
};
export default AnnouncementModal